import { useCallback, useEffect, useState } from 'react'

function readDraft<T>(key: string): T | null {
  try {
    const raw = sessionStorage.getItem(key)
    if (!raw) return null
    return JSON.parse(raw) as T
  } catch {
    return null
  }
}

function writeDraft(key: string, value: unknown) {
  try {
    sessionStorage.setItem(key, JSON.stringify(value))
  } catch {
    /* quota / private mode */
  }
}

export function clearFormDraft(key: string) {
  try {
    sessionStorage.removeItem(key)
  } catch {
    /* ignore */
  }
}

/** Persiste rascunho de formulário em sessionStorage (sobrevive a reload da aba). */
export function useFormDraft<T>(key: string, initial: T, active: boolean) {
  const [value, setValue] = useState<T>(() =>
    active ? (readDraft<T>(key) ?? initial) : initial,
  )

  useEffect(() => {
    if (!active) return
    setValue(readDraft<T>(key) ?? initial)
  }, [active, key, initial])

  useEffect(() => {
    if (!active) return
    writeDraft(key, value)
  }, [active, key, value])

  const clearDraft = useCallback(() => {
    clearFormDraft(key)
  }, [key])

  return [value, setValue, clearDraft] as const
}
